module.exports = __webpack_public_path__ + "img/2023big29.33c9615b.png";